export enum ModalName {
  Application = 'AddOrUpdateOpenIddictApplicationModal',
}
